import { Layout as AntLayout, LayoutProps as AntdLayoutProps } from "antd";
import React from "react";

const { Header, Footer, Sider, Content } = AntLayout;

type LayoutProps = {
  children: React.ReactNode;
  ["data-testid"]?: string;
} & AntdLayoutProps;

const Layout = ({ children, ...props }: LayoutProps) => {
  return (
    <AntLayout
      data-testid={props?.["data-testid"]}
      style={{
        backgroundColor: props.style?.backgroundColor
          ? props.style.backgroundColor
          : "unset", //Overriding this default because it is gray, but each app already has its own background color
      }}
      {...props}
    >
      {children}
    </AntLayout>
  );
};
export default Layout;

Layout.Header = Header;
Layout.Sider = Sider;
Layout.Content = Content;
Layout.Footer = Footer;
